module.exports = __webpack_public_path__ + "assets/61176fb28cf28dfb8642c68af698686a.png";